import { createFileRoute, Navigate } from "@tanstack/react-router";

import { draftView } from "../../../workspaces/worlds/draft-view";

export const Route = createFileRoute(
  "/_console/p/$org/$project/simulate/drafts/$draftId",
)({
  validateSearch: draftView,
  component: MovedDraftRoute,
});

function MovedDraftRoute() {
  return (
    <Navigate
      to="/p/$org/$project/build-worlds/drafts/$draftId"
      params={Route.useParams()}
      search={Route.useSearch()}
      replace
    />
  );
}
